var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from '@serviceos-rn/core';
import { ITipPayloadRepositoryType } from '../ITipPayloadRepository';
let GetAnalyticEventParamsUseCase = class GetAnalyticEventParamsUseCase {
    constructor(payloadRepository) {
        this.payloadRepository = payloadRepository;
    }
    execute(options) {
        var _a, _b, _c;
        const result = {
            choiceItem: undefined,
            value: '',
            type: 'predefined'
        };
        result.choiceItem = options.find(x => !!x.value);
        result.value = ((_a = result.choiceItem) === null || _a === void 0 ? void 0 : _a.title) || '';
        if ((_c = (_b = result.choiceItem) === null || _b === void 0 ? void 0 : _b.choice_items) === null || _c === void 0 ? void 0 : _c[0]) {
            result.value = result.choiceItem.choice_items[0].value;
            result.type = 'custom';
        }
        const booking_transaction_id = this.payloadRepository.getTransactionId().value;
        const position = this.payloadRepository.getPosition().value;
        const booking_id = this.payloadRepository.getBookingID().value;
        if (booking_transaction_id) {
            result.booking_transaction_id = `${booking_transaction_id}`;
        }
        if (position) {
            result.position = `${position}`;
        }
        if (booking_id) {
            result.booking_id = `${booking_id}`;
        }
        return result;
    }
};
GetAnalyticEventParamsUseCase = __decorate([
    injectable(),
    __param(0, inject(ITipPayloadRepositoryType)),
    __metadata("design:paramtypes", [Object])
], GetAnalyticEventParamsUseCase);
export { GetAnalyticEventParamsUseCase };
